import graphql__e4ef6df6093bd3418012 from "./__generated__/MapFilters_map.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import MapFilterList from "./MapFilterList";
import { useFormatMessage } from "../Intl/Context";
import Collapse from "../Utils/Collapse";
import CollapseSwitch from "../Utils/CollapseSwitch";
import CollapseContent from "../Utils/CollapseContent";

const MapFilters = props => {
  const { filterLists } = useFragment(MapFilters_map, props.map);

  const t = useFormatMessage();
  const title = props.title || t(intlMessages.filtersTitle);

  if (!filterLists.length) return null;

  return (
    <div className="map-filters box">
      <Collapse>
        <CollapseSwitch
          className="btn btn-primary-inverse btn-block-md box-shadow btn-expand-height padding-sm d-flex align-items-center"
          hideCaret={true}
          iconClassName="icon-filter"
        >
          {title}
        </CollapseSwitch>

        <CollapseContent>
          <div className="padding-sm">
            {filterLists.map(filterList => (
              <MapFilterList key={filterList.id} filterList={filterList} />
            ))}
          </div>
        </CollapseContent>
      </Collapse>
    </div>
  );
};

const MapFilters_map = graphql__e4ef6df6093bd3418012;

export default MapFilters;

const intlMessages = defineMessages({
  filtersTitle: {
    id: "map.filters.title",
    defaultMessage: "Filtrer les éléments"
  }
});
